<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25">
    <g fill="none" fill-rule="evenodd">
      <g fill-rule="nonzero">
        <g>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <path
                      fill="#164194"
                      d="M.186 12.833c0 2.74 1.69 5.22 4.419 7.016C5.998 20.763 7.658 21.497 9.5 22c1.84-.503 3.501-1.237 4.895-2.151 2.73-1.795 4.419-4.277 4.419-7.016V0H.186v12.833z"
                      transform="translate(-157 -703) translate(127 318) translate(0 151) translate(16 66) translate(0 50) translate(14 118) translate(2 1)"
                    />
                    <path
                      fill="#E1F5FE"
                      d="M2.05 12.833c0 2.017 1.274 3.968 3.589 5.49 1.119.735 2.414 1.328 3.861 1.767 1.446-.44 2.743-1.032 3.86-1.764 2.316-1.525 3.591-3.476 3.591-5.493v-11H2.05v11z"
                      transform="translate(-157 -703) translate(127 318) translate(0 151) translate(16 66) translate(0 50) translate(14 118) translate(2 1)"
                    />
                    <g fill="#13A2E8">
                      <path
                        d="M8.382 0c1.544 0 2.794 1.22 2.794 2.723 0 .751-.312 1.432-.818 1.925L6.248 8.81c-.363.353-.956.353-1.318 0L.818 4.648C.313 4.155 0 3.474 0 2.723 0 1.219 1.251 0 2.794 0c.771 0 1.47.305 1.976.798l.818.797.818-.798C6.912.304 7.611 0 8.382 0zm-.28 1.514c-.447 0-.868.34-1.184.624l-1.33 1.2L4.26 2.139c-.316-.286-.738-.625-1.186-.625-.924 0-1.588.457-1.588 1.291 0 .404.174.784.503 1.08l3.6 3.466 3.55-3.292c.317-.286.492-.665.492-1.07 0-.833-.603-1.475-1.528-1.475z"
                        transform="translate(-157 -703) translate(127 318) translate(0 151) translate(16 66) translate(0 50) translate(14 118) translate(2 1) translate(3.912 5.5)"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>